import _ from 'lodash';
import { routeCreator } from '@adrias-online/steiner/lib/helpers';

import helper from '../../../helpers/steinerHelper';
import routeRegister from '../../../helpers/routeRegister';
import { selectors } from '../reducers/clienti';

const routes = helper.generateRoutes('clienti', selectors);

routes.list.list.breadcrumb = 'Configurazione Clienti';

const list = _.values(routes.list).map(route => ({
    ...route,
    // hotelFilter: true,
    getComponent() {
        return new Promise(resolve => {
            import(/* webpackChunkName: 'clienti' */ `modules/clienti/${
                route.componentPath
                }`).then(response => resolve(response.default));
        });
    }
}));

const links = routeCreator.generateLinks(routes.patterns);

routeRegister.addPatterns('clienti', routes.patterns, {
    it: 'clienti'
});
routeRegister.addLinks('clienti', links);

export default list;
